"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _basisDialog = _interopRequireDefault(require("./basis-dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AlertDialog = function AlertDialog(_ref) {
  var active = _ref.active,
      onCloseDialog = _ref.onCloseDialog,
      content = _ref.content,
      className = _ref.className,
      title = _ref.title,
      alertText = _ref.alertText;
  var actions = [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    key: "alertAction",
    raised: true,
    primary: true,
    className: "action-button alert-button",
    onClick: onCloseDialog
  }, alertText)];
  return /*#__PURE__*/_react["default"].createElement(_basisDialog["default"], {
    active: active,
    className: "alert-dialog ".concat(className),
    onCloseDialog: onCloseDialog,
    content: content,
    title: title,
    actions: actions
  });
};

AlertDialog.propTypes = {
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onCloseDialog: _propTypes["default"].func,
  content: _propTypes["default"].node,
  title: _propTypes["default"].node,
  alertText: _propTypes["default"].node
};

var noop = function noop() {};

AlertDialog.defaultProps = {
  className: '',
  active: false,
  onCloseDialog: noop,
  content: '',
  title: '',
  alertText: ''
};
var _default = AlertDialog;
exports["default"] = _default;